import lozad from 'lozad'

lozad('img[data-src], video[data-src], [data-background-image]').observe()
